import * as React from "react"
import { SaExpertsSlider } from "./saExpertsSlider"

// @ts-ignore
import { saExpertsSection } from "./saExperts.module.scss"
import { saInterfaceExpertsContainer } from "../saTypes"
import useWindowSize from "../saUseWindowDimensions/saUseWindowDimensions"
import { SaExpertsGrid } from "./saExpertsGrid"
import { useEffect, useState } from "react"



export const SaExpertsContainer:React.FC<saInterfaceExpertsContainer> = ({...props}) => {


    let { windowWidth } = useWindowSize()

    const [isMobile, setIsMobile] = useState(null)


    useEffect(() => {
      if (windowWidth >= 768){
        setIsMobile(false)
      }
      else{
        setIsMobile(true)
      }
    },[windowWidth])


    let render = !isMobile ? <SaExpertsGrid {...props}/> : <SaExpertsSlider {...props}/>

    return (
      <section className={saExpertsSection}>
        { render }
      </section>
    )

}
